﻿export default class CarouselHelper {

    static nextIndex = 0;

    static ValidateElements = ($carousel, direction) => {
        $carousel.on('slide.bs.carousel', function (event) {
            if (direction === 'next') {
                let next = $(event.relatedTarget);
                let nextIndex = next.index();
                let items = $carousel.find('.k-input');

                let validator = items.kendoValidator().data('kendoValidator');
                if (!validator.validate()) {
                    return false;
                }            

                //Return and use for actions. 
                CarouselHelper.nextIndex = nextIndex;
            }
        });
    };
}